import { jsx as _jsx } from "react/jsx-runtime";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import "@opala-ds/react/styles.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WebgateProvider } from "@xvia/webgate-connect";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import "./styles/main.css";
import { theme } from "./styles/theme";
const baseName = window.__APP_BASE__ ?? "/";
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsx(React.StrictMode, { children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(BrowserRouter, { basename: baseName, children: _jsx(WebgateProvider, { portalUrl: process.env.PORTAL_URL, children: _jsx(ThemeProvider, { theme: theme, children: _jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(App, {}) }) }) }) }) }) }));
